import React from "react";

interface LicensesSectionProps {
  isEditable: boolean; // kept for API compatibility, not used in partner view
  selectedAssesmentData: any;
}

const LicensesSection: React.FC<LicensesSectionProps> = ({
  selectedAssesmentData,
}) => {
  const netNewLicenses = selectedAssesmentData.partner_new_licenses || 0;
  const totalLicenses = selectedAssesmentData.partner_total_licenses || 0;

  const rows = [
    {
      label: "Net New Licenses",
      value: netNewLicenses.toLocaleString(),
    },
    {
      label: "Total Licenses",
      value: totalLicenses.toLocaleString(),
    },
  ];

  return (
    <div className="detail-section">
      <h2>Licenses</h2>
      <div className="summary-grid">
        {rows.map((row, index) => (
          <div key={index} className="summary-card blue-light">
            <div className="card-content">
              <div className="card-left">
                <span className="card-label">{row.label}</span>
              </div>
              <span className="card-value">{row.value}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LicensesSection;
